<template>
  <div>
    <app-header class="haeder-r"></app-header>
    <!--slider end -->

    <div class="box-title">
      <h2 v-lang.contactus></h2>
    </div>
    <div class="container contact-us-page">
      <div class="row">
          <div class="alert alert-danger errors" v-if="this.err.length > 0">
              <ul>
                  <li v-for="error in err">
                      {{error}}
                  </li>
              </ul>
          </div>

        <div class="col-md-6 col-xs-6">
                <p class="title-contact" v-lang.contactsturkey></p>
          <ul class="">
            <li><i class="fa fa-map-marker" aria-hidden="true"></i>Cihangir Mah. Meşrutiyet Cad. Mehtar Sok. No:1A/0 Acvılar - Istanbul/Turkey</li>
            <li><i class="fa fa-envelope" aria-hidden="true"></i> <p>info@archotek.com</p></li>
            <li><i class="fa fa-envelope" aria-hidden="true"></i> <p>sales@archotek.com</p></li>
            <li><i class="fa fa-mobile" aria-hidden="true"></i> <p>00902124221771</p></li>
            <li><i class="fa fa-fax" aria-hidden="true"></i> <p>00902124221741</p></li>
          </ul>
          <div id="map"  class="map" ></div>
          </div>
        <div class="col-md-6 col-xs-6">
          <p  class="title-contact" v-lang.contactsksa></p>
          <ul class="">
            <li><i class="fa fa-map-marker" aria-hidden="true"></i> <p v-lang.ksaadress></p></li>
            <li><i class="fa fa-envelope" aria-hidden="true"></i> <p> mohamad.b@archotek.com</p></li>
            <li><i class="fa fa-mobile" aria-hidden="true"></i> <p>00966590389407</p></li>
          </ul>
             <div  id="map1" class="map" >
           </div>
        </div>
         <div class="col-md-12 col-xs-12 box-form-and-text">
           <div class="col-md-6 col-sm-6 col-xs-12">
              <h3></h3>
             <p v-lang.contacts></p>
           </div>
           <div class="col-md-6 col-sm-6 col-xs-12">
             <form @submit.prevent="send()" id="cf">
               <div class="form-group">
                 <label for="exampleInputEmail1" v-lang.name></label>
                 <input @change="clean" name="name" v-model="formData.name" type="text" class="form-control" id="text" >
               </div>
               <div class="form-group">
                 <label @change="clean"   for="exampleInputEmail1" v-lang.email></label>
                 <input type="email" v-model="formData.email" name="email" class="form-control" id="exampleInputEmail1" >
               </div>
               <div class="form-group">
                 <label for="exampleInputEmail1" v-lang.message> </label>
                 <textarea @change="clean" name="msg" v-model="formData.message"  class="form-control" rows="3"></textarea>
               </div>
               <div class="box-link">
                 <button type="submit" class="btn-d" v-lang.send>
                   <i class="fa fa-spin fa-spinner" aria-hidden="true" v-if="loading"></i>
                   <i class="fa fa-times  text-danger" aria-hidden="true" v-if="this.err.length > 0"></i>
                   <i class="fa fa-check text-success" aria-hidden="true" v-if="sent"></i>
                 </button>
               </div>
             </form>
           </div>

            <div class="alert alert-success" v-if="sent">
                شكرا لتواصلكم معنا، سيتم الرد عليكم قريباً
            </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import {Urls,allheaders} from '../config'
export default {
  mounted(){
    setTimeout(  () => {
        this.inimap()
        this.inimap1()
    },1000)
  },
    data(){
        return{
              formData: {
                    name : '',
                    email : '',
                    message : ''
                },
                loading: false,
                sent: false,
                err : []
        }
    },
    methods:{
      inimap(){ 
      var map = new google.maps.Map(document.getElementById('map'),{
                        center:{
                            lat: 40.988532,
                            lng: 28.703894
                        },
                        zoom:14,
                        // mapTypeId: 'roadmap'
                    });
                    var marker = new google.maps.Marker({
                        position:{
                              lat: 40.988532,
                            lng: 28.703894
                        },
                        map : map,
                    });
      },
      inimap1(){
      var map1 = new google.maps.Map(document.getElementById('map1'),{
                        center:{
                            lat: 24.751407,
                            lng: 46.766207
                        },
                        zoom:14,
                        // mapTypeId: 'roadmap'
                    });
                    var marker1 = new google.maps.Marker({
                        position:{
                          lat: 24.751407,
                            lng: 46.766207
                        },
                        map : map1,
                    });
      },
       send(){
                this.loading = true
                this.axios.post(Urls.contactsUrl,this.formData, {headers : allheaders})
                    .then( response =>{
                        //sucess
                        console.log(response)
                        this.loading = false
                        this.sent = true
                        this.formData.name = ''
                        this.formData.email = ''
                        this.formData.message = ''
                        setTimeout(() => {
                            this.sent = false}
                            ,5000)
                    }).catch( errors =>{
                    //error
                    this.loading = false
                    this.err = errors.response.data.message
                    setTimeout(() => {
                        this.clean()}
                        ,5000)
                })
            },
            clean(){
                this.err = []
            }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/contact.vue